import { orderBy, filter } from 'lodash'

export const filterAndOrderBlogs = articles => {
  // Show articles if there is no 'postTime' or 'postTime' is in the past.
  // 2018-04-17T00:00+10:00
  const articlesFiltered = filter(articles, article => {
    const currentTime = new Date().getTime()
    const postTime = new Date(article.fields.postTime || '2000-04-19T00:00+10:00').getTime() // Introduce a Y2k Bug
    return currentTime > postTime
  })
  return orderBy(articlesFiltered, 'fields.postTime', 'desc')
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Blog/Blog.utils.js